import { api } from '../api'

const state = {
    statsAds: {
        confirmedCount: 0,
        pendingCount: 0,
        rejectedCount: 0
    },
    statsPlanner: {
        pastPlannerCount: 0,
        currentPlannerCount: 0,
        futurePlannerCount: 0
    },
    statsInteractions: {
        impressionsToday: 0,
        impressionsOverall: 0,
        adClicks: 0,
        outreach: 0,
    },
}

const mutations = {
    // --- ADS ---
    'SET_ADS_STATS'(state, payload) {
        if (payload) {
            Object.assign(state.statsAds, payload)
        }
    },
    // --- PLANNER ---
    'SET_PLANNER_STATS'(state, payload) {
        if (payload) {
            Object.assign(state.statsPlanner, payload)
        }
    },
    // --- INTERACTIONS ---
    'SET_INTERACTIONS_STATS'(state, payload) {
        if (payload) {
            Object.assign(state.statsInteractions, payload)
        }
    },
}

const getters = {
    // --- ADS ---
    getAdsStats: state => {
        return state.statsAds
    },
    // --- PLANNER ---
    getPlannerStats: state => {
        return state.statsPlanner
    },
    // --- INTERACTIONS ---
    getInteractionsStats: state => {
        return state.statsInteractions
    },
}

const actions = {
    // payload has to be the content category (type: string; e.g. news, calendar, elections, ...)
    loadStats: ({ commit, rootState }, payload) => {
        return new Promise(resolve => {
            api.queryAPIServerGet(process.env.VUE_APP_ROOT_API + `/publicitycustomer/stats/${payload}/get`, { pid: rootState.auth.pid, username: rootState.auth.Username }, (response) => {
                let res = response.data;

                if (res.error) {
                    console.log('An error occured. Please try again later.');
                    resolve(1);
                }
                commit(`SET_${payload.toUpperCase()}_STATS`, res.data)

                resolve(0);
            })
        })
    }
}

export default {
    state,
    mutations,
    getters,
    actions
}
